module.exports = __webpack_public_path__ + "static/media/folder-dark.8d58d185.svg";